import { render, staticRenderFns } from "./phrases.vue?vue&type=template&id=86838c34&scoped=true"
import script from "./phrases.vue?vue&type=script&lang=js"
export * from "./phrases.vue?vue&type=script&lang=js"
import style0 from "./phrases.vue?vue&type=style&index=0&id=86838c34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86838c34",
  null
  
)

export default component.exports